<div class="warning-modal">
  <div class="modal-header">
    <i class="fa fa-exclamation-triangle mt-2 fa-lg"></i>
    <div class="ml-5 header-label" [innerHTML]="headerLabel"></div>
  </div>
  <div class="confirm modal-body">
    <div class="content" [innerHTML]="title"></div>
    <div class="buttons">
      <button type="button" class="btn success-button" (click)="confirm()" [innerHTML]="confirmLabel"></button>
      <button type="button" class="btn decline-button" (click)="decline()" [innerHTML]="declineLabel"></button>
    </div>
  </div>
</div>
